import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';

export const reviewsApi = createApi({
  reducerPath: 'recommends',

  baseQuery: createBaseQueryWithReauth('/recommends'),
 

  tagTypes: ['Recommends'],

  endpoints: builder => ({
    getClientRecommends: builder.query({
      query: ({ page = 1 } = {}) => {

        const params = {
          page, // додаємо параметр page до запиту

        };
        return {
          url: ``,
          method: 'GET',
          params,
        };
      },
      transformResponse: (response, meta) => {
        const pagination = {
          currentPage: meta.response.headers.get('x-pagination-current-page'),
          pageCount: meta.response.headers.get('x-pagination-page-count'),
          perPage: meta.response.headers.get('x-pagination-per-page'),
          totalCount: meta.response.headers.get('x-pagination-total-count'),
        };
        return { data: response, pagination };
      },
      providesTags: ['Recommends'],
    }),


    deleteRecommends: builder.mutation({
      query: ( id ) => ({
        url: `/delete?id=${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Recommends'],
    }),
  }),
});

export const {
  useDeleteRecommendsMutation,
  useGetClientRecommendsQuery
  
} = reviewsApi;
